const initialState = [];

export const selectedScheduleReducer = (state = initialState, action) => {
    if (action.type === 'SET_SCHEDULE_SELECTED') {
        const count = state.some(item => action.payload.id === item.programId);
        if (count === false) {
            return [...state, action.payload]
        } else {
            return state.map((item) => {
                if (item.programId === action.payload.programId) {
                    return { ...item, ...action.payload }
                }
                return item
            })
        }
    } else if (action.type === 'UNSET_SCHEDULE_SELECTED') {
        return state.filter((item) => action.payload.programId !== item.programId);
    } else if (action.type === 'SET_PARTICIPANT_TO_SCHEDULE') {
        return state.map((item) => {
            if (item.programId === action.programId) {
                return {
                    ...item,
                    participants: [...item.participants, action.payload]
                }
            }
            return item
        })
    } else if (action.type === 'UNSET_PARTICIPANT_TO_SCHEDULE') {
        return state.map((item) => {
            if (item.programId === action.programId) {
                return {
                    ...item,
                    participants: item.participants.filter((p) => p.email !== action.payload)
                }
            }
            return item
        })
    } else if (action.type === 'UPDATE_PARTICIPANT_TO_SCHEDULE') {
        return state.map((item) => {
            if (item.programId === action.programId) {
                return {
                    ...item,
                    participants: item.participants.map(
                        (participant, i) => participant.email === action.payload.emailOld ?
                            {
                                ...participant,
                                email: action.payload.email,
                                firstName: action.payload.firstName,
                                lastName: action.payload.lastName,
                                mobilePhone: action.payload.mobilePhone,
                            }
                            :
                            participant
                    )
                }
            }
            return item
        })
    }
    return state
}